const cellSize = 'calc(7vmin)'
const backgroundColor = '#282c34'
export { cellSize, backgroundColor }